import { router } from '@inertiajs/vue3'

// eslint-disable-next-line no-undef
const apiKey = VITE_POSTHOG_API_KEY
// eslint-disable-next-line no-undef
const host = VITE_POSTHOG_API_URL

let posthog = null
let organizationId = null

function pauseOnOrganizationChange({ detail: { visit } }) {
  if (!visit.prefetch && !visit.url.pathname.startsWith(`/${organizationId}/`)) {
    posthog?.opt_out_capturing()
  }
}

async function syncPosthog({ posthog: tracking, user, organization }) {
  if (tracking === undefined) {
    return
  }
  if (!tracking) {
    posthog?.opt_out_capturing()
    return
  }
  organizationId = organization.id
  if (!posthog) {
    posthog = (await import('posthog-js')).default
    posthog.init(apiKey, { api_host: host, defaults: '2025-05-24', capture_pageview: false })
  }
  if (posthog.has_opted_out_capturing()) {
    posthog.opt_in_capturing({ captureEventName: false })
  }
  posthog.identify(user.id, { organization_id: organization.id })
  posthog.capture('$pageview')
}

export function resetPosthog() {
  posthog?.reset()
}

export default function usePosthog() {
  if (apiKey && host) {
    router.on('start', pauseOnOrganizationChange)
    router.on('navigate', event => syncPosthog(event.detail.page.props))
  }
}
